// src/components/ImportJsonPopup.js
import React, { useState } from 'react';
import './CellEditorPopup.css'; // Tận dụng lại CSS của popup cũ cho nhanh

const ImportJsonPopup = ({ onImport, onClose }) => {
  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleImportClick = async () => {
    setError(null);
    if (!jsonText.trim()) {
      setError("Vui lòng dán chuỗi JSON vào.");
      return;
    }

    try {
      // 1. Thử parse JSON để kiểm tra cú pháp
      const parsedData = JSON.parse(jsonText);
      
      setIsProcessing(true);
      // 2. Gọi hàm xử lý import từ component cha
      await onImport(parsedData);
      setIsProcessing(false);
      onClose(); // Đóng popup khi thành công

    } catch (e) {
      setIsProcessing(false);
      console.error("JSON Invalid:", e);
      setError("Chuỗi JSON không hợp lệ. Vui lòng kiểm tra lại cú pháp.");
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{ minWidth: '500px' }}>
        <h4>Import Levels từ JSON</h4>

        <div className="form-group">
          <label>Dán JSON vào đây (theo cấu trúc đã định nghĩa):</label>
          <textarea
            style={{ width: '100%', height: '300px', fontFamily: 'monospace', padding: '10px' }}
            value={jsonText}
            onChange={(e) => setJsonText(e.target.value)}
            placeholder='{ "easy": [...], "medium": [...] }'
            disabled={isProcessing}
          />
          {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>

        <div className="popup-actions">
          <button 
            onClick={handleImportClick} 
            className="popup-button save" 
            disabled={isProcessing}
            style={{ backgroundColor: isProcessing ? '#ccc' : '#28a745' }}
          >
            {isProcessing ? 'Đang xử lý...' : 'IMPORT NGAY'}
          </button>
          <button 
            onClick={onClose} 
            className="popup-button cancel"
            disabled={isProcessing}
          >
            Hủy
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportJsonPopup;